// extracted by mini-css-extract-plugin
module.exports = {"main":"Login_main__7YOlD","form":"Login_form__Pxc-d"};